import React, { useState, useEffect, useCallback } from "react";
import { TopBar } from "../../shared/topBar/TopBar";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { Admin } from "./Admin/Admin";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { ClientStatementTab } from "./clientStatementTab/ClientStatementTab";
import { ToastContainer } from "react-toastify";
import { Batch } from "./batch/Batch";
import { Review } from "./review/Review";
import { getUserPageAccess } from "../../../config/apiConfig";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { sbaAxios } from "../../utils/sbaAxios";
import { Unauthorized } from "../../shared/ErrorPage/ErrorPage";
const Level = [
  { BreadCrumb: "CRM >", Routes: `${UrlPath.Investor}` }, { BreadCrumb: "Client Statements", Routes: `${UrlPath.ClientStatements}` },
];
const date = new Date();
const reportDate = new Date(date.getFullYear(), date.getMonth(), 0);
const CSDetails = () => {
  const [activeTab, setActiveTab] = useState('ClientStatement');
  const [statementDate, setStatementDate] = useState(reportDate);

  const [admintabAccess, setAdmintabAccess] = useState(false);
  const [batchtabAccess, setBatchtabAccess] = useState(false);
  const [reviewtabAcess, setReviewtabAcess] = useState(false);
  const [loader, setLoader] = useState(true);
  const [render, setRender] = useState(false);
  useEffect(() => {
    document.title = `Client Statements`;
    getClientstatementAccess();
  }, []);

  const getClientstatementAccess = async () => {

    try {
      const clientStatementAdminTabAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=ClientStatementAdminTabAccess` });
      const clientStatementBatchTabAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=ClientStatementBatchTabAccess` });
      const clientStatementReviewTabAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=ClientStatementReviewTabAccess` });
      const [
        clientStatementAdminTabAccessResponse,
        clientStatementBatchTabAccessResponse,
        clientStatementReviewTabAccessResponse
      ] = await Promise.all([
        clientStatementAdminTabAccessPromise,
        clientStatementBatchTabAccessPromise,
        clientStatementReviewTabAccessPromise
      ]);

      setAdmintabAccess(clientStatementAdminTabAccessResponse);
      setBatchtabAccess(clientStatementBatchTabAccessResponse);
      setReviewtabAcess(clientStatementReviewTabAccessResponse);
      setLoader(false);
    } catch (error) {
      console.error("An error occurred:", error);
      setLoader(false);
    }
  };

  const handleOnSelect = useCallback((e) => {
    setActiveTab(e);
  }, []);

  return (
    <>
      <TopBar label={"Client Statements"} />
      <div id="content" className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="p-4">
          {loader ? <><LoadingScreen /></> :
            <Tabs
              activeKey={activeTab}
              id="uncontrolled-tab-example"
              className="ms-3"
              onSelect={handleOnSelect}
            >


              <Tab eventKey="ClientStatement" title="Client Statement">
                <div className="p-3 bg-white life-science rounded">
                  {activeTab === "ClientStatement" && <ClientStatementTab />}
                </div>
              </Tab>
              <Tab eventKey="Batch" title="Batch">
                {activeTab === "Batch" && <div className="p-3 bg-white life-science rounded">
                  {!batchtabAccess ? (
                   <><Unauthorized /></>
                  ) : (
                    <Batch statementDate={statementDate} setStatementDate={setStatementDate} />
                  )}
                </div>}

              </Tab>

              <Tab eventKey="Review" title="Review">
                {activeTab === "Review" && <div className="p-3 bg-white life-science rounded">
                  {!reviewtabAcess ? (
                    <> <><Unauthorized /></> </>
                  ) : (<>
                    <Review csDate={statementDate} setCSDate={setStatementDate} />
                  </>
                  )}


                </div>}

              </Tab>

              <Tab eventKey="Admin" title="Admin">
                <div className="p-3 bg-white life-science rounded">

                  <div className="row m-0">
                    <div className="col-lg-12 px-0">
                      {activeTab === "Admin" && <>
                        {!admintabAccess ? (
                          <> <><Unauthorized /></> </>
                        ) : (
                          <Admin />)}
                      </>
                      }
                    </div>
                  </div>
                </div>

              </Tab>

            </Tabs>}
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default React.memo(CSDetails);
